module.exports = __webpack_public_path__ + "static/media/live_tracking_user.19e0d34e.svg";